import { Box, Button, Card, Stack, Text, rem } from '@mantine/core'
import { IconArrowRight, IconHistory } from '@tabler/icons-react'
import { Link } from '@tanstack/react-router'

interface HistoryLinkCardProps {
  propertyId: number
}

export function HistoryLinkCard({ propertyId }: HistoryLinkCardProps) {
  return (
    <Box
      component={Link}
      to="/maintenance-log"
      search={{ propertyId } as any}
      style={{ textDecoration: 'none', display: 'block', height: '100%' }}
    >
      <Card
        withBorder
        radius="lg"
        p="xl"
        style={{
          height: '100%',
          minHeight: rem(300),
          cursor: 'pointer',
          transition: 'all 0.2s',
        }}
      >
        <Stack align="center" gap="md" pt="md">
          <Box
            style={{
              width: rem(64),
              height: rem(64),
              borderRadius: '50%',
              backgroundColor: 'var(--mantine-color-brandOrange-1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <IconHistory size={32} color="var(--mantine-color-brandOrange-6)" />
          </Box>
          <Text fw={600} size="lg" ta="center">
            Huoltohistoria
          </Text>
          <Text size="sm" c="dimmed" ta="center">
            Näytä kaikki tehdyt huoltotehtävät
          </Text>
          <Button
            variant="filled"
            color="brandOrange"
            rightSection={<IconArrowRight size={16} />}
            mt="sm"
          >
            Avaa historia
          </Button>
        </Stack>
      </Card>
    </Box>
  )
}
